
import React from 'react'
import { BrandAwareButton as Button } from '@/components/brand/BrandAwareButton'
import { Calendar, Clock, History } from 'lucide-react'

interface ChartTimeframeSelectorProps {
  selectedTimeframe: 'today' | 'last7days' | 'last30days' | 'custom'
  onTimeframeChange: (timeframe: 'today' | 'last7days' | 'last30days' | 'custom') => void
}

export const ChartTimeframeSelector = ({ selectedTimeframe, onTimeframeChange }: ChartTimeframeSelectorProps) => {
  return (
    <div className="flex items-center gap-2 mb-4">
      <Button
        variant={selectedTimeframe === 'today' ? 'default' : 'outline'}
        size="sm"
        onClick={() => onTimeframeChange('today')}
        className="text-xs"
      >
        <Clock className="h-4 w-4 mr-1" />
        Today
      </Button>
      <Button
        variant={selectedTimeframe === 'last7days' ? 'default' : 'outline'}
        size="sm"
        onClick={() => onTimeframeChange('last7days')}
        className="text-xs"
      >
        <Calendar className="h-4 w-4 mr-1" />
        Last 7 Days
      </Button>
      <Button
        variant={selectedTimeframe === 'last30days' ? 'default' : 'outline'}
        size="sm"
        onClick={() => onTimeframeChange('last30days')}
        className="text-xs"
      >
        <History className="h-4 w-4 mr-1" />
        Last 30 Days
      </Button>
    </div>
  )
}
